module.exports = __webpack_public_path__ + "img/1880.039cfa1.jpg";